import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface BrandState {
  primaryColor: string;
  accentColor: string;
  successColor: string;
  logoLightUrl: string;
  logoDarkUrl: string;
  faviconUrl: string;
}

/** Default (unbranded) SmartContractor palette. Applied whenever there is no tenant brand loaded —
 *  signed out, or a tenant that hasn't customised its colors — so the previous tenant's brand never
 *  lingers on public/onboarding pages. */
export const DEFAULT_BRAND = {
  primaryColor: '#4E38B5',
  accentColor: '#850CF0',
  successColor: '#10B981',
} as const;

const initialState: BrandState = {
  primaryColor: DEFAULT_BRAND.primaryColor,
  accentColor: DEFAULT_BRAND.accentColor,
  successColor: DEFAULT_BRAND.successColor,
  logoLightUrl: '',
  logoDarkUrl: '',
  faviconUrl: '',
};

const brandSlice = createSlice({
  name: 'brand',
  initialState,
  reducers: {
    setBrand(state, action: PayloadAction<Partial<BrandState>>) {
      return { ...state, ...action.payload };
    },
  },
});

export const { setBrand } = brandSlice.actions;
export default brandSlice.reducer;
